import { candidatesStore } from "@/services/indexedDB.service";

const Candidates = {
    namespaced: true,
    state: {
    },
    mutations: {},
    actions: {
    },
    getters: {
        getAllCandidates: (state, getters, rootState) => {
            return rootState.UI.candidates;
        }
    },

};

export default Candidates;